/**
 * Browser shim for the `btoa` npm package.
 *
 * The npm `btoa` package is a Node.js polyfill that uses `Buffer`. In the browser,
 * `btoa` is a native global — no Buffer needed. This shim redirects any
 * `import`/`require` of the npm package to the native browser function.
 *
 * Consumers (e.g. shared-components/api/api-user.js) do:
 *   const btoa = require('btoa');
 * Vite resolves that to this file instead of node_modules/btoa.
 */
export default (str) => globalThis.btoa(str);
